import React, { useState } from "react";
import { Col, Form, Radio, Row, Select } from "antd";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";


import {SurveysRightBar,typeList} from './surveysData'
import Responses from "./components/Responses";
import Analysis from "./components/Analysis";

function Surveys() {
  const [tabComponent, setTabComponent] = useState("Responses");
  const handleModeChange = (e) => {
    setTabComponent(e.target.value);
  };
  const handleType = (value) => {
    console.log(`selected ${value}`);
  };

  return (
    <>
      <div>
        <PageHeading heading="Surveys" />
        <Form layout="horizontal">
          <Row>
            <Col span={4}>
              <Form.Item label="Type:">
                <Select
                  defaultValue="Maintenance"
                  onChange={handleType}
                  options={[]}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <h2 style={{ fontWeight: "400" }}>Maintenance Surveys</h2>
        <Radio.Group
          onChange={handleModeChange}
          value={tabComponent}
          style={{
            marginBottom: 8,
          }}
        >
          <Radio.Button value="Responses">Responses</Radio.Button>
          <Radio.Button value="Analysis">Analysis</Radio.Button>
        </Radio.Group>
     
        {tabComponent === "Responses" ? 
        <Responses/>: <Analysis/>}
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={SurveysRightBar} />
      </div>
    </>
  );
}

export default Surveys;
